import * as Sentry from '@sentry/react';

/**
 * Records a non-PHI breadcrumb so the patient's path can be reconstructed if an
 * error is later captured (e.g. by the app error boundary). Breadcrumbs are
 * buffered and only sent when attached to a captured event, so they cost nothing
 * on the happy path — unlike Sentry.logger.*, which ingests every call.
 *
 * PHI GUARD: never pass answer content, names, phone/email, DOB, or file
 * contents. Only structural metadata is allowed — node ids/subtypes, step names,
 * counts, booleans, file type/size, and error codes.
 */
export const addFlowBreadcrumb = (
  message: string,
  data?: Record<string, string | number | boolean | null | undefined>,
) => {
  Sentry.addBreadcrumb({
    category: 'patient-flow',
    level: 'info',
    message,
    data,
  });
};
